import { Loader } from '@googlemaps/js-api-loader';
import { useAsync } from 'react-async-hook';

export const useGetGoogleServices = (GOOGLE_API_KEY: string) => {
	return useAsync(async () => {
		const mapsLoader = new Loader({
			apiKey: GOOGLE_API_KEY,
			version: 'weekly',
		});

		const places: google.maps.PlacesLibrary = await mapsLoader.importLibrary('places');

		let autoComplete: google.maps.places.AutocompleteService;
		let placesService: google.maps.places.PlacesService;

		if (places.PlacesService) {
			placesService = new places.PlacesService(document.createElement('div'));
		} else {
			throw new Error('PlacesService is not available in the Google Maps API');
		}

		if (places.AutocompleteService) {
			autoComplete = new places.AutocompleteService();
		} else {
			throw new Error('AutocompleteService is not available in the Google Maps API');
		}

		return {
			autoCompleteService: autoComplete,
			getPlaceDetails: placesService,
			sessionToken: places.AutocompleteSessionToken,
		};
	}, []);
};
